import React from 'react';
import Box from '@mui/material/Box';

/**
 * Adds padding, margin, and consistent background and border to the review
 * parts in this step. Really just a Box.
 */
export const ReviewContainer = ({children}: {children: React.ReactNode}) => (
    <Box sx={{mb: 3, p: 3, background: 'white', borderRadius: 4}}>{children}</Box>
);
